module.exports = __webpack_public_path__ + "img/img_value.487fe64d.png";